/**
 * Названия табов (секций) панели отбора
 */
export const enum ESelectionPanelTabs {
  AdmissionSurvey = 'admission_survey',
  Applications = 'applications',
  Testing = 'testing',
  Users = 'users',
  Enrolled = 'enrolled',
}
